<template>
  <div>
    <v-progress-linear
      indeterminate
      v-show="action && action.pending"
      class="ma-0"
    ></v-progress-linear>
    <v-alert
      :type="messageState.messageType"
      :value="showMessage"
      :transition="messagesTransition"
      class="ma-0 status-success"
      >
      {{messageState.message}}
    </v-alert>
  </div>
</template>

<script>
import { appConstant } from '../../app.constant';
import { VAlert } from 'vuetify/es5/components/VAlert';
import { VProgressLinear } from 'vuetify/es5/components/VProgressLinear';

export default {
  name: 'StatusBar',
  data: () => ({
    messageState: {},
  }),
  props: {
    action: {
      type: Object,
      required: appConstant.DEFAULT_SUBMIT_SUCCESS_MESSAGE,
    },
    successText: {
      type: String,
      default: null,
    },
    successDuration: {
      type: Number,
      default: 2500,
    },
    errorText: {
      type: String,
      default: appConstant.DEFAULT_SUBMIT_ERROR_MESSAGE,
    },
    errorDuration: {
      type: Number,
      default: null,
    },
    messagesTransition: {
      type: String,
      default: 'scroll-x-transition',
    },
  },
  components: {
    VAlert,
    VProgressLinear,
  },
  watch: {
    'action.state': function handleSuccessState(value, prevValue) {
      let messageType = null;
      let message = null;
      let duration = null;
      if (value === 'ready' && prevValue === 'pending') {
        messageType = 'success';
        message = this.successText;
        duration = this.successDuration;
      } else if (value === 'failed' && prevValue === 'pending') {
        messageType = 'error';
        message = this.errorText;
        duration = this.errorDuration;
      }

      this.setMessageState(messageType, message, this.action.id, duration);
    },
  },
  methods: {
    setMessageState(messageType, message, relatedActionId, duration) {
      this.messageState = { messageType, message, relatedActionId };
      if (parseInt(duration, 10) > 0) {
        setTimeout(() => {
          if (this.messageState.relatedActionId === relatedActionId) {
            // Keep the message type so the alert stays a consistent style during the leave transition.
            this.messageState = { messageType };
          }
        }, duration);
      }
    },
  },
  computed: {
    showMessage() {
      return (
        this.messageState.hasOwnProperty('message') &&
        this.messageState.hasOwnProperty('relatedActionId') &&

        this.messageState.message && this.messageState.message.length > 0 &&
        this.messageState.relatedActionId !== null &&
        this.messageState.relatedActionId !== undefined
      );
    },
  },
};
</script>
